/**
 * Painting question visibility rules (showIf exact-match + showIfIncludes array check).
 * Mirrors the legacy RequestWizard visibility logic exactly.
 */
export const isPaintingQuestionVisible = (q, answers) => {
  if (q.showIf) {
    for (const [key, value] of Object.entries(q.showIf)) {
      const answer = answers[key];
      if (Array.isArray(value)) {
        if (!value.includes(answer)) return false;
      } else if (answer !== value) {
        return false;
      }
    }
  }

  if (q.showIfIncludes) {
    for (const [key, value] of Object.entries(q.showIfIncludes)) {
      const answer = answers[key];
      if (!Array.isArray(answer) || !answer.includes(value)) return false;
    }
  }

  return true;
};
